'use strict';
/** eslint-disable max-len */

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _translate = _interopRequireDefault(require("../translate"));

var _advancedFetch = _interopRequireDefault(require("../advanced-fetch"));

var _reactRedux = require("react-redux");

var _lodash = _interopRequireDefault(require("lodash.assign"));

var _translateUrl = _interopRequireDefault(require("./translateUrl"));

var _metadata = _interopRequireDefault(require("../../lib/metadata"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

var Footer = /*#__PURE__*/function (_React$Component) {
  _inherits(Footer, _React$Component);

  function Footer(props) {
    var _this;

    _classCallCheck(this, Footer);

    _this = _possibleConstructorReturn(this, (Footer.__proto__ || Object.getPrototypeOf(Footer)).call(this, props));
    _this.changeLanguage = _this.changeLanguage.bind(_assertThisInitialized(_this));
    _this.stickyRef = null;
    return _this;
  }

  _createClass(Footer, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var activeLanguage = this.props.i18n.language;
      var t = this.props.t;
      var theme = document.body.classList.item(0);
      return /*#__PURE__*/_react.default.createElement("nav", {
        className: 'footer'
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: 'row'
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: 'column medium-6'
      }, /*#__PURE__*/_react.default.createElement("h2", null, t('Wichtige Seiten')), /*#__PURE__*/_react.default.createElement("ul", {
        className: 'footer-navigation-list'
      }, ['menu-about', 'menu-disclaimer', 'menu-impressum'].map(function (item, key) {
        var link = t("".concat(item, " link ").concat(theme));
        return /*#__PURE__*/_react.default.createElement("li", {
          key: key,
          className: 'footer-navigation-item'
        }, /*#__PURE__*/_react.default.createElement("a", {
          href: link,
          onClick: function onClick(e) {
            return _this2.navigate(e, link);
          }
        }, t("".concat(item, " ").concat(theme))));
      }))), /*#__PURE__*/_react.default.createElement("div", {
        className: 'column medium-6'
      }, this.props.i18n.options.locales.length > 1 && /*#__PURE__*/_react.default.createElement("ul", {
        className: 'footer-language-menu'
      }, this.props.i18n.options.locales.map(function (language, key) {
        var className = "footer-language-menu-item ".concat(language === activeLanguage ? 'active' : '');
        return /*#__PURE__*/_react.default.createElement("li", {
          key: key,
          className: className
        }, /*#__PURE__*/_react.default.createElement("a", {
          onClick: function onClick(e) {
            return _this2.changeLanguage(e, language, null, _this2.props.isHome || false);
          }
        }, language.toUpperCase()));
      })), /*#__PURE__*/_react.default.createElement("div", {
        className: 'social-media'
      }, /*#__PURE__*/_react.default.createElement("a", {
        href: t('instagram_link'),
        icon: "instagram",
        className: "instagram",
        target: '_blank'
      }, /*#__PURE__*/_react.default.createElement("svg", {
        id: "Komponente_21_1",
        "data-name": "Komponente 21 \u2013 1",
        xmlns: "http://www.w3.org/2000/svg",
        width: "41",
        height: "41",
        viewBox: "0 0 41 41"
      }, /*#__PURE__*/_react.default.createElement("rect", {
        id: "Rechteck_2532",
        "data-name": "Rechteck 2532",
        width: "41",
        height: "41",
        rx: "4"
      }), /*#__PURE__*/_react.default.createElement("g", {
        id: "instagram_4_",
        "data-name": "instagram(4)",
        transform: "translate(7.543 7.547)"
      }, /*#__PURE__*/_react.default.createElement("g", {
        id: "Gruppe_252",
        "data-name": "Gruppe 252",
        transform: "translate(0.005)"
      }, /*#__PURE__*/_react.default.createElement("g", {
        id: "Gruppe_251",
        "data-name": "Gruppe 251",
        transform: "translate(0)"
      }, /*#__PURE__*/_react.default.createElement("path", {
        id: "Pfad_62",
        "data-name": "Pfad 62",
        d: "M19.433,0H6.481A6.5,6.5,0,0,0,0,6.476V19.429A6.5,6.5,0,0,0,6.481,25.9H19.433a6.5,6.5,0,0,0,6.476-6.476V6.476A6.5,6.5,0,0,0,19.433,0ZM23.75,19.429a4.322,4.322,0,0,1-4.317,4.317H6.481a4.323,4.323,0,0,1-4.317-4.317V6.476A4.322,4.322,0,0,1,6.481,2.159H19.433A4.322,4.322,0,0,1,23.75,6.476V19.429Z",
        transform: "translate(-0.005)",
        fill: "#007844"
      }))), /*#__PURE__*/_react.default.createElement("g", {
        id: "Gruppe_254",
        "data-name": "Gruppe 254",
        transform: "translate(18.355 4.317)"
      }, /*#__PURE__*/_react.default.createElement("g", {
        id: "Gruppe_253",
        "data-name": "Gruppe 253"
      }, /*#__PURE__*/_react.default.createElement("circle", {
        id: "Ellipse_1",
        "data-name": "Ellipse 1",
        cx: "1.619",
        cy: "1.619",
        r: "1.619",
        fill: "#007844"
      }))), /*#__PURE__*/_react.default.createElement("g", {
        id: "Gruppe_256",
        "data-name": "Gruppe 256",
        transform: "translate(6.481 6.476)"
      }, /*#__PURE__*/_react.default.createElement("g", {
        id: "Gruppe_255",
        "data-name": "Gruppe 255"
      }, /*#__PURE__*/_react.default.createElement("path", {
        id: "Pfad_63",
        "data-name": "Pfad 63",
        d: "M108.881,102.4a6.476,6.476,0,1,0,6.476,6.476A6.475,6.475,0,0,0,108.881,102.4Zm0,10.794a4.318,4.318,0,1,1,4.317-4.318A4.318,4.318,0,0,1,108.881,113.194Z",
        transform: "translate(-102.405 -102.4)",
        fill: "#007844"
      })))))), /*#__PURE__*/_react.default.createElement("a", {
        href: t('facebook_link'),
        icon: "facebook",
        target: '_blank'
      }, /*#__PURE__*/_react.default.createElement("svg", {
        id: "Komponente_22_1",
        "data-name": "Komponente 22 \u2013 1",
        xmlns: "http://www.w3.org/2000/svg",
        width: "41",
        height: "41",
        viewBox: "0 0 41 41"
      }, /*#__PURE__*/_react.default.createElement("rect", {
        id: "Rechteck_2533",
        "data-name": "Rechteck 2533",
        width: "41",
        height: "41",
        rx: "4"
      }), /*#__PURE__*/_react.default.createElement("g", {
        id: "facebook-app-symbol",
        transform: "translate(-23.516 7.548)"
      }, /*#__PURE__*/_react.default.createElement("path", {
        id: "f_1_",
        d: "M46.022,25.9V14.089h3.964l.595-4.606H46.022V6.543c0-1.333.369-2.242,2.283-2.242h2.437V.18A33.044,33.044,0,0,0,47.189,0c-3.516,0-5.923,2.146-5.923,6.087v3.4H37.29v4.606h3.976V25.9Z",
        fill: "#007844"
      })))), /*#__PURE__*/_react.default.createElement("a", {
        href: t('youtube_link'),
        icon: "youtube",
        target: '_blank'
      }, /*#__PURE__*/_react.default.createElement("svg", {
        id: "Komponente_23_1",
        "data-name": "Komponente 23 \u2013 1",
        xmlns: "http://www.w3.org/2000/svg",
        width: "41",
        height: "41",
        viewBox: "0 0 41 41"
      }, /*#__PURE__*/_react.default.createElement("rect", {
        id: "Rechteck_2534",
        "data-name": "Rechteck 2534",
        width: "41",
        height: "41",
        rx: "4"
      }), /*#__PURE__*/_react.default.createElement("g", {
        id: "youtube_6_",
        "data-name": "youtube(6)",
        transform: "translate(6.844 -48.894)"
      }, /*#__PURE__*/_react.default.createElement("g", {
        id: "Gruppe_257",
        "data-name": "Gruppe 257",
        transform: "translate(0 59.72)"
      }, /*#__PURE__*/_react.default.createElement("path", {
        id: "Pfad_65",
        "data-name": "Pfad 65",
        d: "M26.932,62.886a3.051,3.051,0,0,0-2.45-2.5,87.775,87.775,0,0,0-21.651,0,3.05,3.05,0,0,0-2.451,2.5,55.8,55.8,0,0,0,0,13.015,3.049,3.049,0,0,0,2.451,2.5,87.775,87.775,0,0,0,21.651,0,3.049,3.049,0,0,0,2.45-2.5A55.8,55.8,0,0,0,26.932,62.886ZM11.38,73.947v-9.1l6.828,4.552Z",
        transform: "translate(0 -59.72)",
        fill: "#007844"
      }))))), /*#__PURE__*/_react.default.createElement("a", {
        href: t('tiktok_link'),
        icon: "tiktok",
        target: '_blank'
      }, /*#__PURE__*/_react.default.createElement("svg", {
        id: "Komponente_24_1",
        "data-name": "Komponente 24 \u2013 1",
        xmlns: "http://www.w3.org/2000/svg",
        width: "41",
        height: "41",
        viewBox: "0 0 41 41"
      }, /*#__PURE__*/_react.default.createElement("rect", {
        id: "Rechteck_2535",
        "data-name": "Rechteck 2535",
        width: "41",
        height: "41",
        rx: "4"
      }), /*#__PURE__*/_react.default.createElement("g", {
        id: "tik-tok_1_",
        "data-name": "tik-tok(1)",
        transform: "translate(-21.143 8.477)"
      }, /*#__PURE__*/_react.default.createElement("path", {
        id: "Pfad_64",
        "data-name": "Pfad 64",
        d: "M51.852,6.215A5.862,5.862,0,0,1,48.31,5.032,5.863,5.863,0,0,1,45.969.39h-3.8V10.77l0,5.686A3.444,3.444,0,1,1,39.8,13.193V9.336a7.475,7.475,0,0,0-1.1-.081A7.284,7.284,0,0,0,33.234,11.7a7.138,7.138,0,0,0,.322,9.843,7.411,7.411,0,0,0,.686.6,7.285,7.285,0,0,0,4.465,1.51,7.476,7.476,0,0,0,1.1-.081,7.26,7.26,0,0,0,4.056-2.028,7.112,7.112,0,0,0,2.134-5.061l-.02-8.49a9.626,9.626,0,0,0,5.89,2V6.214h-.011Z",
        transform: "translate(0)",
        fill: "#007844"
      }))))), /*#__PURE__*/_react.default.createElement("div", {
        className: "copyright ".concat(activeLanguage)
      }, t("".concat(theme, " copyright"))))), /*#__PURE__*/_react.default.createElement("div", {
        className: "footer-slogan ".concat(activeLanguage)
      }));
    }
  }, {
    key: "changeLanguage",
    value: function changeLanguage(e, language, theme, isHome) {
      var _this3 = this;

      e.preventDefault();
      (0, _advancedFetch.default)('/api/change-language', {
        credentials: 'include',
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          lang: language
        })
      }).then(function () {
        var _this3$props = _this3.props,
            i18n = _this3$props.i18n,
            t = _this3$props.t,
            history = _this3$props.history,
            searchSuggestions = _this3$props.searchSuggestions;
        i18n.changeLanguage(language, function (err) {
          if (err) void 0;
          document.documentElement.setAttribute('lang', i18n.language);
          searchSuggestions({});
          var pathParts = history.location.pathname.split('/'); // if there is a projectname translate it and add it to the last part of the location

          if (_this3.props.match && _this3.props.match.params.projectname) {
            pathParts[pathParts.length - 1] = t("".concat(_this3.props.match.params.projectname, "-filter"));
          }

          var pathname = pathParts.join('/');
          (0, _metadata.default)(t("".concat(theme, " | Hofsuche")), t("".concat(theme, " | metadescription")));
          var translatedUrl = (0, _translateUrl.default)(pathname, history.location.search, language, _this3.props);
          history.push("".concat(translatedUrl).concat(isHome ? '#home' : ''));
        });
      });
    }
    /**
     *
     * @param e
     * @param path
     */

  }, {
    key: "navigate",
    value: function navigate(e, path) {
      if (!path.startsWith('/')) return;
      e.preventDefault();
      this.props.history.push(path);
    }
  }]);

  return Footer;
}(_react.default.Component);

Footer.propTypes = {
  t: _propTypes.default.func.isRequired,
  menu: _propTypes.default.arrayOf(_propTypes.default.shape({
    url: _propTypes.default.string,
    onclick: _propTypes.default.func,
    link: _propTypes.default.string.isRequired,
    active: _propTypes.default.bool
  })),
  i18n: _propTypes.default.shape({
    language: _propTypes.default.string,
    changeLanguage: _propTypes.default.func,
    options: _propTypes.default.shape({
      locales: _propTypes.default.arrayOf(_propTypes.default.string)
    })
  }),
  history: _propTypes.default.shape({
    push: _propTypes.default.func.isRequired,
    location: _propTypes.default.shape({
      pathname: _propTypes.default.string
    })
  }),
  isHome: _propTypes.default.bool,
  activeFilter: _propTypes.default.shape({
    project: _propTypes.default.array
  }),
  match: _propTypes.default.shape({
    params: _propTypes.default.shape({
      pathname: _propTypes.default.string,
      projectname: _propTypes.default.string
    })
  }),
  searchSuggestions: _propTypes.default.func
};
/**
 * Maps state from redux to props of the component. use this only for container-component.
 *
 * @param state
 * @returns {{languages: Array|*|string[]}}
 */

var mapStateToProps = function mapStateToProps(state) {
  return (0, _lodash.default)({}, state.farm);
};

var _default = (0, _reactRedux.connect)(mapStateToProps)((0, _translate.default)(Footer));

exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./client/components/footer/index.js
// module id = 278
// module chunks = 0